export default __webpack_public_path__ + "static/media/fkoriginal.8501cf93.svg";